import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'

const IpdVisitSlice = createSlice({
  name: 'IpdVisit',
  initialState: {
    query: '',
    param: '',
    patientId: '',
    id: '',
    updation: false,
    selectedTab: 'vitals',
    selectedVisitId: null,
    reload: 0,
    patientFhirId: null,
  },
  reducers: {
    setQueryParam: (state, action) => {
      state.query = action.payload.q ?? state.query
      state.param = action.payload.param ?? state.param
      state.patientId = action.payload.patientId ?? state.patientId
      state.id = action.payload.id ?? state.id
      state.selectedTab = action.payload.selectedTab ?? state.selectedTab
      state.selectedVisitId =
        action.payload.selectedVisitId ?? state.selectedVisitId
      state.reload = action.payload.reload ?? state.reload
      state.patientFhirId = action.payload.patientFhirId ?? state.patientFhirId
    },
  },
})

export const { setQueryParam } = IpdVisitSlice.actions
export const selectQuery = (state: RootState) => state.IpdVisit.query
export const selectParam = (state: RootState) => state.IpdVisit.param
export const selectPatientId = (state: RootState) => state.IpdVisit.patientId
export const selectId = (state: RootState) => state.IpdVisit.id
export const selectedTabs = (state: RootState) => state.IpdVisit.selectedTab
export const selectedVisitId = (state: RootState) =>
  state.IpdVisit.selectedVisitId
export const selectedReload = (state: RootState) => state.IpdVisit.reload
export const selectPatientFhirId = (state: RootState) =>
  state.IpdVisit.patientFhirId
export default IpdVisitSlice.reducer
